import React, { Component } from 'react';
import {
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  TablePagination
} from '@material-ui/core';

import kinopoisk from '../config/kinopoisk';

class AuthorsTable extends Component {
  state = {
    page: 0,
    rowsPerPage: 10
  };

  constructUrl = kpid => kinopoisk.mainAuthorUrlPart + kpid.toString();

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: Number(event.target.value) });
  };

  render() {
    const { rowsPerPage, page } = this.state;
    // const emptyRows =
    //   rowsPerPage -
    //   Math.min(rowsPerPage, this.props.authors.length - page * rowsPerPage);
    return (
      <div className="authors-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Никнейм</TableCell>
              <TableCell>Адрес профиля</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.authors
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(author => (
                <TableRow key={author.kpid} hover>
                  <TableCell align="left">{author.nickname}</TableCell>
                  <TableCell align="left">
                    <Button
                      variant="contained"
                      href={this.constructUrl(author.kpid)}
                      target="_blank"
                    >
                      {'user/' + author.kpid.toString()}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                labelRowsPerPage={''}
                // rowsPerPageOptions={[5, 10, 25]}
                rowsPerPageOptions={[10]}
                // colSpan={3}
                count={this.props.authors.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  native: true
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                // ActionsComponent={TablePaginationActionsWrapped}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    );
  }
}

export default AuthorsTable;



// WEBPACK FOOTER //
// ./src/components/AuthorsTable.jsx